// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dJO0giT0Jeo8OBcjkEqr{align-items:center;min-height:40px;padding:8px 12px 8px 8px}.bGKXKIIMCgAADwV2pS8o{padding-left:4px}.iYTBHMhKiDEIDz3x6N7F{align-items:center;height:24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiSelect": `dJO0giT0Jeo8OBcjkEqr`,
	"empty": `bGKXKIIMCgAADwV2pS8o`,
	"placeholder": `iYTBHMhKiDEIDz3x6N7F`
};
export default ___CSS_LOADER_EXPORT___;
